import {styled} from '@vw-marketing/us-components';

export const StyledLandingWrapper: any = styled.div`
         width: 100%;
         overflow-x: hidden;
       `;
